import React from "react";
import HeroGirl from "./../../assets/images/hero_girl.png";
import HeroGirlMob from "./../../assets/images/hero_girl_mob.png";
import Hero2 from "./../../assets/images/hero_2.png";
import Amzoon from "./../../assets/images/amzoon_dark.png";
import "./hero.css";
const Hero = () => {
  const shopNow = () => {
    window.open(
      'https://a.co/d/1Tnoxt3',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  return (
    <div className="hero">
      <div className="hero_inner">
        <div className="hero_left">
          <p className="hero_heading">Reveal Your Natural Glow</p>
          <p className="hero_description">
            Enhance Absorption and Maximize the Benefits of Your Skincare
            Products
          </p>
          <button onClick={()=> shopNow()}>Shop now</button>
          <div>
            <img src={Amzoon} alt="" width="100%" className="amzoon"/>
          </div>
          <div className="hero_mobile">
            <img src={Hero2} alt="" />
          </div>
        </div>
        <div className="hero_right">
          <div className="hero_desktop">
            <img src={Hero2} alt="" />
          </div>
          <div className="girl_img_desk">
            <img src={HeroGirl} alt="" />
          </div>
        </div>

        <img src={HeroGirlMob} alt="" className="girl_img_mob" />
      </div>
    </div>
  );
};

export default Hero;
